<template>
    <div class="wrap">
        <el-row class="memberInfo">
            <el-col :span="10" class="left">
                <el-row>
                    <el-col :span="4" class="avatarWrap">
                        <el-avatar shape="square" :size="50" :src="squareUrl"></el-avatar>
                    </el-col>
                    <el-col :span="20" class="info">
                        <p class="first_p">
                            <span>刘高海</span>
                            <span class="two">女</span>
                            <span>53岁</span>
                        </p>
                        <p><span>13544441111</span></p>
                    </el-col>
                </el-row>

            </el-col>
            <el-col :span="12" class="right">
                <div class="label">标签</div>
                <div class="labels">
                    <el-tag v-for="(item,index) in tags" :key="index" :type="item.type" effect="dark">
                        {{ item.label }}
                    </el-tag>
                </div>
            </el-col>
        </el-row>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="selectMenu" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item index="1">基础信息</el-menu-item>
            <!-- <el-menu-item index="2">处理中心</el-menu-item> -->
            <!-- <el-menu-item index="3">处理中心</el-menu-item> -->
            <!-- <el-submenu index="2">
                <template slot="title">我的工作台</template>
                <el-menu-item index="2-1">选项1</el-menu-item>
                <el-menu-item index="2-2">选项2</el-menu-item>
                <el-menu-item index="2-3">选项3</el-menu-item>
                <el-submenu index="2-4">
                    <template slot="title">选项4</template>
                    <el-menu-item index="2-4-1">选项1</el-menu-item>
                    <el-menu-item index="2-4-2">选项2</el-menu-item>
                    <el-menu-item index="2-4-3">选项3</el-menu-item>
                </el-submenu>
            </el-submenu> -->
            <!-- <el-menu-item index="3" disabled>消息中心</el-menu-item> -->
            <!-- <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
        </el-menu>
        <div class="index1">
            <el-divider content-position="left" class="myDivider">个人信息</el-divider>
            <el-form label-width="130px">
                <el-form-item label="会员姓名">朱晓琳</el-form-item>
                <el-form-item label="手机号码">13800138000</el-form-item>
                <el-form-item label="微信">13800132832</el-form-item>
                <el-form-item label="住址">深圳市宝安区</el-form-item>
                <el-form-item label="年龄">16岁</el-form-item>
                <el-form-item label="性别">男</el-form-item>
                <el-form-item label="档案归属">本人</el-form-item>
                <el-form-item label="会员类型">慢病会员</el-form-item>
                <el-form-item label="病症">高血压、糖尿病</el-form-item>
                <el-form-item label="家庭成员"></el-form-item>
                <el-form-item label="">
                    <el-row :gutter="20">
                        <el-col :span="8">姓名：朱大龙</el-col>
                        <el-col :span="8">手机号码：13988654511</el-col>
                        <el-col :span="8">关系：儿子</el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">姓名：朱大龙</el-col>
                        <el-col :span="8">手机号码：13988654511</el-col>
                        <el-col :span="8">关系：儿子</el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">姓名：朱大龙</el-col>
                        <el-col :span="8">手机号码：13988654511</el-col>
                        <el-col :span="8">关系：儿子</el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="归属门店">深圳南山南头古城店</el-form-item>
                <el-form-item label="归属成员">张胜利</el-form-item>
                <el-form-item label="备注">
                    <div class="remark">巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉</div>
                </el-form-item>
            </el-form>
            <el-divider content-position="left" class="myDivider">既往史</el-divider>
            <el-form label-width="130px">
                <el-form-item label="疾病史">朱晓琳</el-form-item>
                <el-form-item label="药物过敏史">13800138000</el-form-item>
                <el-form-item label="遗传史">13800132832</el-form-item>
                <el-form-item label="用药史">13800132832</el-form-item>
            </el-form>
        </div>
        <div class="hidden"></div>
    </div>
</template>

<script>
export default {
    components: {
    },
    computed: {},
    watch: {},
    created() {
        // this.getPrescriptionDetailInfo();
        // 取到路由带过来的参数
        const routerParams = this.$route.query.mallCode
        // 将数据放在当前组件的数据内
        console.log(routerParams);
    },
    data() {
        return {
            squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
            tags: [
                {
                    label: '谈尿布',
                    tpye: '1',
                },
                {
                    label: '谈尿布2',
                    tpye: '12',
                },
            ],
            activeIndex: '1'
        }
    },
    methods: {
        selectMenu(key, keyPath) {
            console.log(key, keyPath);
        }
    },
}
</script>

<style lang="less" scoped>
.wrap {
    background: #fff;
}
.memberInfo {
    padding: 20px;
    .left {
        border-right: 1px solid #e4e4e4;
        .info {
            color: #333;
            font-size: 15px;
            .first_p {
                margin-bottom: 15px;
                .two {
                    margin: 0 35px;
                }
            }
        }
    }
    .right {
        padding: 0 20px;
        .label {
            margin-bottom: 10px;
        }
        .labels /deep/ .el-tag:first-child {
            margin-left: 0;
        }
        .labels /deep/ .el-tag {
            margin-left: 15px;
        }
    }
}
.remark {
    padding: 10px;
    background: #eee;
    width: 400px;
}
.hidden {
    height: 20px;
    background: #fff;
}
</style>
